import { Redirect } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { useQueryParams } from '../../hooks/useQueryParams'
import useAuth from '../../utils/auth/useAuth'

const RedirectToHome = () => {
  const { isLoading, isAuthenticated, user } = useAuth()
  const [userLocale, setUserLocale] = useState('')
  const query = useQueryParams()

  useEffect(() => {
    const setDefaultLocale = () => {
      const defaultLocale = user.userLocale
      setUserLocale(defaultLocale)
    }
    if (isAuthenticated && user) {
      setDefaultLocale()
    }
  }, [isAuthenticated, user])

  if (!isLoading && isAuthenticated && userLocale) {
    return <Redirect to={`/${userLocale}/showroom`} />
  }

  if (!isLoading && !isAuthenticated && query.get('enforceLogin') === 'true') {
    return <Redirect to="/auth0" />
  }

  return !isLoading && <Redirect to="/en_IE/view" />
}

export default RedirectToHome
